module.exports = "/_next/static/images/folder-icon-mobile-d055339e4859f55cfe796903f82e8a2e.png";